import {
  aCustomMatchListColumn,
  anUpdateCustomMatchListColumn,
  mockUpdateCustomMatchListColumnOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const updateCustomMatchListColumnHandler = ({ id, fields, name }) => ({
  data: {
    __typename: 'Mutation',
    updateCustomMatchListColumn: anUpdateCustomMatchListColumn({
      data: aCustomMatchListColumn({
        id,
        fields,
        name,
      }),
    }),
  },
});

export const handlers = [
  mockUpdateCustomMatchListColumnOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          updateCustomMatchListColumn: anUpdateCustomMatchListColumn(),
        },
      });
    }
  ),
];
